var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSendMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line_expanded",
    height: 512,
    viewBox: "0 0 16 16",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 2h-13c-.827 0-1.5.673-1.5 1.5v9c0 .827.673 1.5 1.5 1.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-7c-.275 0-.5-.224-.5-.5v-8.98l6.687 5.37c.091.073.203.11.313.11s.222-.037.313-.11l6.687-5.37v4.98c0 .276.224.5.5.5s.5-.224.5-.5v-5c0-.827-.673-1.5-1.5-1.5zm-6.5 5.859-6.05-4.859h12.1zm5.854 1.287c-.143-.142-.358-.185-.545-.108s-.309.26-.309.462v.5h-2.5c-.276 0-.5.224-.5.5v2c0 .276.224.5.5.5h2.5v.5c0 .202.122.385.309.462.061.026.127.038.191.038.13 0 .258-.051.354-.146l2-2c.195-.195.195-.512 0-.707zm.115 3.179c-.072-.19-.254-.325-.469-.325h-2.5v-1h2.5c.215 0 .397-.135.469-.325l.824.825z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendMessage);
export default __webpack_public_path__ + "static/media/icon-send-message.b92a6c9349ae9f6f88748e83893c524e.svg";
export { ForwardRef as ReactComponent };